const unavailableVideoHosts = new Set([
  'video-5.ggjav.com',
  'video-6.ggjav.com',
]);

export function getVideoSourceHost(url) {
  try {
    return new URL(url).hostname.toLowerCase();
  } catch (error) {
    return '';
  }
}

export function isVideoSourceAvailable(url, status = 1) {
  const host = getVideoSourceHost(url);
  if (!host || Number(status) === 0) {
    return false;
  }

  // The development API has not run the daily availability task yet.
  // Production visibility is controlled by the backend vod_status value.
  return process.env.NODE_ENV !== 'development' || !unavailableVideoHosts.has(host);
}
